import Constant from '@/const';
import axios from 'axios';

const putLaboratory = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/laboratory/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putLaboratory;
